import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "../../components/Header/Header"; // Adjust path as needed

const TermsConditions = () => {
  const [termsContent, setTermsContent] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTermsContent = async () => {
      try {
        const response = await axios.get(
          "https://auth.ssccglpinnacle.com/api/footer"
        );

        if (response.data && response.data.length > 0) {
          setTermsContent(response.data[0].terms_conditions || "");
        } else {
          setError("Failed to load Terms and Conditions content");
        }
      } catch (error) {
        console.error("Error fetching Terms and Conditions content:", error);
        setError(
          "An error occurred while fetching Terms and Conditions content"
        );
      } finally {
        setLoading(false);
      }
    };

    fetchTermsContent();
  }, []);

  return (
    <>
      <Header />
      <div className="min-h-screen bg-[#F9F9F9] px-4 md:px-12 py-8 text-gray-800">
        <h1 className="text-2xl md:text-3xl font-bold text-center mb-6">
          Terms & Conditions
        </h1>

        {loading && (
          <div className="flex justify-center items-center min-h-[200px]">
            <img
              src="/Bubble-Preloader.gif"
              alt="Loading"
              className="w-12 h-12"
            />
          </div>
        )}

        {error && (
          <p className="text-red-600 text-center font-medium">{error}</p>
        )}

        {!loading && !error && (
          <div
            className="prose prose-sm md:prose-base max-w-none text-left leading-relaxed"
            dangerouslySetInnerHTML={{ __html: termsContent }}
          />
        )}
      </div>
    </>
  );
};

export default TermsConditions;
